import React from 'react';
import { DEFAULT_MULTIVALUE_SEPARATOR, enumColumnTypes } from '../../types';
export var createItemFromOption = function (option, getIconByValue) {
    if (!option) {
        return null;
    }
    switch (option.type) {
        case enumColumnTypes.ICON_TYPE:
            return typeof getIconByValue === 'function' ? getIconByValue(option.value) : null;
        default:
            return option.label ? option.label : option.value;
    }
};
export var getOptionFromOptions = function (options, value) { return options.find(function (o) { return o.value === value; }); };
var EnumCell = function (_a) {
    var value = _a.value, options = _a.options, getIconByValue = _a.getIconByValue;
    var formattedValue = Array.isArray(value)
        ? value.map(function (singleValue) { return createItemFromOption(getOptionFromOptions(options, singleValue), getIconByValue); }).join(DEFAULT_MULTIVALUE_SEPARATOR)
        : createItemFromOption(getOptionFromOptions(options, value), getIconByValue);
    return (React.createElement("span", null, formattedValue));
};
export default EnumCell;
//# sourceMappingURL=EnumCell.js.map